import { render, staticRenderFns } from "./edito-navigation.vue?vue&type=template&id=05f49c3e"
import script from "./edito-navigation.vue?vue&type=script&lang=js"
export * from "./edito-navigation.vue?vue&type=script&lang=js"
import style0 from "./edito-navigation.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PatternsSiteBreadcrumb: require('/home/node/app/components/patterns/site-breadcrumb/site-breadcrumb.vue').default,ElementsUiWrapper: require('/home/node/app/components/elements/ui-wrapper/ui-wrapper.vue').default,PatternsSelectTabNavigation: require('/home/node/app/components/patterns/select-tab-navigation/select-tab-navigation.vue').default})
